import React from 'react';
import BarChartIcon from '@material-ui/icons/BarChart';
import {
  createFrontendPlugin,
  createRouteRef,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';

// The sidebar's nav items are auto-discovered from page extensions, but ONLY
// pages that register a routeRef - AppNav skips routeRef-less pages entirely
// (the page still renders at its path, it just never gets a nav entry).
const rootRouteRef = createRouteRef();

const OrgInsightsPageExtension = PageBlueprint.make({
  params: {
    path: '/org-insights',
    title: 'Engineering',
    icon: React.createElement(BarChartIcon),
    routeRef: rootRouteRef,
    loader: async () => {
      const { OrgInsightsPage } = await import('./OrgInsightsPage');
      return React.createElement(OrgInsightsPage);
    },
  },
});

export const orgInsightsPlugin = createFrontendPlugin({
  pluginId: 'org-insights',
  routes: {
    root: rootRouteRef,
  },
  extensions: [OrgInsightsPageExtension],
});
